import * as stylex from '@stylexjs/stylex'

export const colors = stylex.defineConsts({
  playPaper: 'var(--softmax-color-play-paper)',
  playInk: 'var(--softmax-color-play-ink)',
  playMuted: 'var(--softmax-color-play-muted)',
  playHeroShade: 'var(--softmax-color-play-hero-shade)',
  editorialBody: 'var(--softmax-color-editorial-body)',
  editorialStrong: 'var(--softmax-color-editorial-strong)',
  editorialIcon: 'var(--softmax-color-editorial-icon)',
  editorialSubtitle: 'var(--softmax-color-editorial-subtitle)',
  editorialHairline: 'var(--softmax-color-editorial-hairline)',
  editorialLink: 'var(--softmax-color-editorial-link)',
  editorialMuted: 'var(--softmax-color-editorial-muted)',
  editorialTableBorder: 'var(--softmax-color-editorial-table-border)',
  marketingEyebrow: 'var(--softmax-color-marketing-eyebrow)',
  marketingQuiet: 'var(--softmax-color-marketing-quiet)',
  marketingCardBorder: 'var(--softmax-color-marketing-card-border)',
  marketingCardHover: 'var(--softmax-color-marketing-card-hover)',
  marketingCardActive: 'var(--softmax-color-marketing-card-active)',
  marketingBackground: 'var(--softmax-color-marketing-background)',
  marketingForeground: 'var(--softmax-color-marketing-foreground)',
  marketingSecondary: 'var(--softmax-color-marketing-secondary)',
  marketingBorder: 'var(--softmax-color-marketing-border)',
  background: 'var(--softmax-color-background)',
  surface: 'var(--softmax-color-surface)',
  surfaceAlt: 'var(--softmax-color-surface-alt)',
  foreground: 'var(--softmax-color-foreground)',
  muted: 'var(--softmax-color-muted)',
  subtle: 'var(--softmax-color-subtle)',
  border: 'var(--softmax-color-border)',
  borderStrong: 'var(--softmax-color-border-strong)',
  hairline: 'var(--softmax-color-hairline)',
  overlayBorder: 'var(--softmax-color-overlay-border)',
  dialogBackdrop: 'var(--softmax-color-dialog-backdrop)',
  placeholder: 'var(--softmax-color-placeholder)',
  action: 'var(--softmax-color-action)',
  actionForeground: 'var(--softmax-color-action-foreground)',
  actionHover: 'var(--softmax-color-action-hover)',
  selected: 'var(--softmax-color-selected)',
  selectedSurface: 'var(--softmax-color-selected-surface)',
  inverse: 'var(--softmax-color-inverse)',
  inverseMuted: 'var(--softmax-color-inverse-muted)',
  danger: 'var(--softmax-color-danger)',
  attention: 'var(--softmax-color-attention)',
  secondary: 'var(--softmax-color-secondary)',
  hover: 'var(--softmax-color-hover)',
  codeSurface: 'var(--softmax-color-code-surface)',
  dangerSurface: 'var(--softmax-color-danger-surface)',
  chartBlue: 'var(--softmax-color-chart-blue)',
  chartOrange: 'var(--softmax-color-chart-orange)',
  chartGreen: 'var(--softmax-color-chart-green)',
  chartPurple: 'var(--softmax-color-chart-purple)',
  chartNeutral: 'var(--softmax-color-chart-neutral)',
  chartPink: 'var(--softmax-color-chart-pink)',
  chartRed: 'var(--softmax-color-chart-red)',
  chartPeach: 'var(--softmax-color-chart-peach)',
  chartMagenta: 'var(--softmax-color-chart-magenta)',
  chartLime: 'var(--softmax-color-chart-lime)',
  chartCyan: 'var(--softmax-color-chart-cyan)',
  chartYellow: 'var(--softmax-color-chart-yellow)',
  chartPeriwinkle: 'var(--softmax-color-chart-periwinkle)',
  chartGlass: 'var(--softmax-color-chart-glass)',
  chartGrid: 'var(--softmax-color-chart-grid)',
  chartGridFaint: 'var(--softmax-color-chart-grid-faint)',
  terminalSurface: 'var(--softmax-color-terminal-surface)',
  terminalText: 'var(--softmax-color-terminal-text)',
  terminalMuted: 'var(--softmax-color-terminal-muted)',
  chatMuted: 'var(--softmax-color-chat-muted)',
})

export const fonts = stylex.defineConsts({
  sans: 'var(--softmax-font-sans)',
  serif: 'var(--softmax-font-serif)',
  mono: 'var(--softmax-font-mono)',
  interface: 'var(--softmax-font-interface)',
  marketingSans: 'var(--softmax-font-marketing-sans)',
  marketingMono: 'var(--softmax-font-marketing-mono)',
})

export const radii = stylex.defineConsts({
  small: 'var(--softmax-radius-small)',
  medium: 'var(--softmax-radius-medium)',
  dialog: 'var(--softmax-radius-dialog)',
  pill: 'var(--softmax-radius-pill)',
  large: 'var(--softmax-radius-large)',
  extraLarge: 'var(--softmax-radius-extra-large)',
})

export const fontSizes = stylex.defineConsts({
  editorialBody: 'var(--softmax-font-size-editorial-body)',
  editorialCard: 'var(--softmax-font-size-editorial-card)',
  caption: 'var(--softmax-font-size-caption)',
  sectionTitle: 'var(--softmax-font-size-section-title)',
  dialogTitle: 'var(--softmax-font-size-dialog-title)',
  pageTitle: 'var(--softmax-font-size-page-title)',
  pageTitleWide: 'var(--softmax-font-size-page-title-wide)',
  reading: 'var(--softmax-font-size-reading)',
  small: 'var(--softmax-font-size-small)',
  body: 'var(--softmax-font-size-body)',
  label: 'var(--softmax-font-size-label)',
  title: 'var(--softmax-font-size-title)',
  display: 'var(--softmax-font-size-display)',
  section: 'var(--softmax-font-size-section)',
  coworldTitle: 'var(--softmax-font-size-coworld-title)',
})

export const lineHeights = stylex.defineConsts({
  small: 'var(--softmax-line-height-small)',
  label: 'var(--softmax-line-height-label)',
  reading: 'var(--softmax-line-height-reading)',
  dialogTitle: 'var(--softmax-line-height-dialog-title)',
})

export const layers = stylex.defineConsts({
  navigation: 'var(--softmax-layer-navigation)',
  backdrop: 'var(--softmax-layer-backdrop)',
  modal: 'var(--softmax-layer-modal)',
  popup: 'var(--softmax-layer-popup)',
  tooltip: 'var(--softmax-layer-tooltip)',
})

export const controlSizes = stylex.defineConsts({
  field: 'var(--softmax-control-size-field)',
  checkbox: 'var(--softmax-control-size-checkbox)',
  navigation: 'var(--softmax-control-size-navigation)',
  compact: 'var(--softmax-control-size-compact)',
  touch: 'var(--softmax-control-size-touch)',
})

export const elevation = stylex.defineConsts({
  dialog: 'var(--softmax-shadow-dialog)',
  tooltip: 'var(--softmax-shadow-tooltip)',
  navigation: 'var(--softmax-shadow-navigation)',
})

export const spacing = stylex.defineConsts({
  space0: 'var(--softmax-space-0)',
  space2: 'var(--softmax-space-2)',
  space4: 'var(--softmax-space-4)',
  space6: 'var(--softmax-space-6)',
  space8: 'var(--softmax-space-8)',
  space10: 'var(--softmax-space-10)',
  space12: 'var(--softmax-space-12)',
  space14: 'var(--softmax-space-14)',
  space16: 'var(--softmax-space-16)',
  space20: 'var(--softmax-space-20)',
  space24: 'var(--softmax-space-24)',
  space28: 'var(--softmax-space-28)',
  space32: 'var(--softmax-space-32)',
  space36: 'var(--softmax-space-36)',
  space40: 'var(--softmax-space-40)',
  space44: 'var(--softmax-space-44)',
  space48: 'var(--softmax-space-48)',
  space56: 'var(--softmax-space-56)',
  space64: 'var(--softmax-space-64)',
  space72: 'var(--softmax-space-72)',
})

export const sizes = stylex.defineConsts({
  articleDialog: 'var(--softmax-size-article-dialog)',
  editorial: 'var(--softmax-size-editorial)',
  content: 'var(--softmax-size-content)',
  page: 'var(--softmax-size-content)',
  account: 'var(--softmax-size-account)',
  headerText: 'var(--softmax-size-header-text)',
  headerGroup: 'var(--softmax-size-header-group)',
})

export const breakpoints = stylex.defineConsts({
  coarse: '@media (any-pointer: coarse)',
  coarsePrimary: '@media (pointer: coarse)',
  reducedMotion: '@media (prefers-reduced-motion: reduce)',
  compact: '@media (max-width: 639px)',
  playCompact: '@media (max-width: 760px)',
  medium: '@media (min-width: 768px)',
  wide: '@media (min-width: 1024px)',
})

export const motion = stylex.defineConsts({
  loadingRevealDuration: 'var(--softmax-duration-loading-reveal)',
  editorialDuration: 'var(--softmax-duration-editorial)',
  spinnerDuration: 'var(--softmax-duration-spinner)',
  navigationDuration: 'var(--softmax-duration-navigation)',
  navigationEasing: 'var(--softmax-easing-navigation)',
})

export const sweep = stylex.defineConsts({
  pink: 'var(--softmax-color-sweep-pink)',
  yellow: 'var(--softmax-color-sweep-yellow)',
  cyan: 'var(--softmax-color-sweep-cyan)',
  mint: 'var(--softmax-color-sweep-mint)',
  border: 'var(--softmax-color-sweep-border)',
  quiet: 'var(--softmax-color-sweep-quiet)',
  height: 'var(--softmax-control-size-sweep)',
  paddingBlock: 'var(--softmax-space-sweep-block)',
  duration: 'var(--softmax-duration-sweep)',
  quickDuration: 'var(--softmax-duration-sweep-quick)',
  easing: 'var(--softmax-easing-sweep)',
})

export const watch = stylex.defineConsts({
  progressTrack: 'var(--softmax-color-watch-progress-track)',
  controlRadius: 'var(--softmax-radius-watch-control)',
  eyebrowSize: 'var(--softmax-font-size-watch-eyebrow)',
  unitSize: 'var(--softmax-font-size-watch-unit)',
  divisionSize: 'var(--softmax-font-size-watch-division)',
  slashSize: 'var(--softmax-font-size-watch-slash)',
  titleSize: 'var(--softmax-font-size-watch-title)',
  titleWideSize: 'var(--softmax-font-size-watch-title-wide)',
})
